import React from 'react';

import { Text } from '@simplybusiness/mobius-core';
import { withPartnerTheme, theme } from '@simplybusiness/mobius-simplybusiness';

const ErrorMessage = withPartnerTheme(({ children }) => (
  <Text
    style={{
      marginTop: '8px',
      marginBottom: 0,
      fontSize: '14px',
      color: theme.colors.error,
    }}
  >
    {children}
  </Text>
));

export default ErrorMessage;
